import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';
import { GfTitleService } from '../../../../../services/core.title.service';
import { ProjectService } from '../../../../../services/project.service';
import { UiService } from '../../../../../services/core.ui.service';
import { ScmAclService } from '../../../services/project.scm.acl.service';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'project-admin-scm-acl',
  template: require('./project.admin.scm.acl.html')
})
export class ProjectAdminScmAclComponent implements OnInit {
  @Input() project: any;
  @Input() acl: any;
  @Input() roles: any;
  @Input() scm: any;
  @Input() isProjectAdmin: any;

  adminRoles: any;
  nonAllowedRoles: any;
  newPath: string = "";
  toRemove: any = false;
  options: any;
  hasUserAcls: any;
  getRolePermission: any;
  getRolePermissionValue: any;
  getRolePermissionLabel: any;
  getRolePermissionCSSClass: any;
  aclToApi: any;
  userAclToRemove: any = false;
  unixName: string;

  constructor(
    private stateService: StateService,
    private titleService: GfTitleService,
    private projectService: ProjectService,
    private uiService: UiService,
    private scmAclService: ScmAclService
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.project.name, 'Admin', 'SCM Access Control');
    this.unixName = this.stateService.params.unixName;

    this.adminRoles = this.scmAclService.getAdminRoles(this.roles);
    this.nonAllowedRoles = this.scmAclService.getNonAllowedRoles(this.roles);
    this.roles = this.scmAclService.getConfigurableRoles(this.roles);
    this.newPath = "";
    this.toRemove = false;
    this.options = this.scmAclService.getScmAccessOptions();

    this.hasUserAcls = _.partial(this.scmAclService.hasUserAcls, this.acl);
    this.getRolePermission = this.scmAclService.getRolePermission;
    this.getRolePermissionValue = _.partial(this.scmAclService.getRolePermissionValue, this.roles);
    this.getRolePermissionLabel = this.scmAclService.getRolePermissionLabel;
    this.getRolePermissionCSSClass = this.scmAclService.getRolePermissionCSSClass;
    this.aclToApi = this.scmAclService.mapping.aclToApi;
    this.userAclToRemove = false;
  }

  addModule(): boolean {
    if (_.get(this, 'newPath', '').trim() === '') {
      this.uiService.message.showWarning("The new path/branch name must not be blank", "Add Path/Branch");
      return false;
    }
    if (this.scmAclService.path.pathExists(this.acl, this.newPath)) {
      this.uiService.message.showWarning("The specified path/branch already exists", "Add Path/Branch");
      return false;
    }
    const newModule = this.scmAclService.path.createPath(this.newPath, this.roles);
    this.projectService.postAcl(this.unixName, newModule).then(
      (response: any) => {
        this.uiService.message.showSuccess("Created ACL entry for " + this.newPath, "Add Path/Branch");
        this.acl.push(response);
        this.newPath = "";
      },
      () => {
        this.uiService.message.showError("Could not create ACL entry for " + this.newPath, "Add Path/Branch");
      }
    );
    return true;
  }

  setRolePermission(aclEntry: any, roleId: any, newPermission: any): void {
    this.scmAclService.setRolePermission(aclEntry, roleId, newPermission);
    if (aclEntry) {
      this.projectService.postAcl(this.unixName, this.scmAclService.mapping.aclToApi(aclEntry)).then(() => {
        this.uiService.message.showSuccess("Updated ACL entry for " + aclEntry.path, 'Update SCM ACL');
      });
    }
  }

  removeModule(module: any): void {
    if (module.id) {
      this.projectService.deleteAcl(_.get(this.stateService.params, 'unixName', ''), module.id).then(
        () => {
          this.uiService.message.showSuccess(module.path + " was removed.", "Remove Path/Branch");
          this.acl = this.scmAclService.path.removePath(this.acl, module.path);
          this.toRemove = false;
        },
        () => {
          this.uiService.message.showWarning("Could not remove " + module.path, "Remove Path/Branch");
        }
      );
    }
  }

  selectUserAclToRemove(element: any, userAcl: any): void {
    if (this.userAclToRemove != userAcl) {
      this.userAclToRemove = userAcl;
    } else {
      this.scmAclService.removeUserPermission(element, userAcl);
      this.projectService.postAcl(this.unixName, this.scmAclService.mapping.aclToApi(element)).then(() => {
        this.uiService.message.showSuccess("Updated ACL entry for " + element.path, 'Update SCM ACL');
      });
    }
  }

  selectToRemove(element: any): void {
    if (this.toRemove != element) {
      this.toRemove = element;
    } else {
      this.removeModule(element);
    }
  }

  cancelRemove(): void {
    this.toRemove = false;
    this.userAclToRemove = false;
  }
}
